import _ from '../utils/lodash';
import cssParser from 'css-selector-parser';
// import { attrCode, normalize } from '../services/contextService';
import { normalize } from './normalize';
import attrCode from './attrCode';

export function getCSSSelectorRegEx (selector) {
  if (!selector) {
    return '';
  }
  let rulesetNodes = parseCSSSelector(selector);
  rulesetNodes = noramlizeRuleset(rulesetNodes);
  let regexStr = generateRuleSetRegEx(rulesetNodes);
  return regexStr;
}

export function parseCSSSelector (selector) {
  let parser = new cssParser.CssSelectorParser();
  // TODO: support more generic modifiers based on https://www.npmjs.com/package/css-selector-parser
  /*
  parser.registerSelectorPseudos('has');
  parser.registerNestingOperators('>', '+', '~');
  parser.registerAttrEqualityMods('^', '$', '*', '~');
  parser.enableSubstitutes();
  */
  parser.registerNestingOperators('>');
  parser.registerAttrEqualityMods('*');
  let result = parser.parse(selector);
  let rulesetNodes = [];
  if (result.type === 'selectors') {
    result.selectors.forEach((ruleset) => {
      rulesetNodes.push(parseCSSRule(ruleset));
    });
  } else {
    // ruleset, i.e. single css selector
    rulesetNodes.push(parseCSSRule(result));
  }
  return rulesetNodes;
}

function parseCSSRule (ruleset) {
  let nodes = [];
  let rule = ruleset.rule;
  while (rule) {
    let node = [];
    node.nestingOperator = rule.nestingOperator;
    if (rule.tagName) {
      node.push({
        name: 'tag',
        value: rule.tagName
      });
    }

    let id;
    let idOp;
    if (rule.id) {
      id = rule.id;
    } else if (rule.attrs) {
      // id in the form of [id=...]
      rule.attrs.forEach(attr => {
        if (attr.name === 'id') {
          id = attr.value;
          if (attr.operator) idOp = attr.operator;
        }
      });
    }
    if (typeof id !== 'undefined') {
      if (id) {
        node.push({
          name: 'id',
          value: id,
          operator: idOp || ''
        });
      }
      // TODO else
      // match any non empty id
    }

    if (rule.classNames) {
      node.push({
        name: 'class',
        value: rule.classNames.join(' '),
        nestingOperator: rule.nestingOperator
      });
    }
    if (rule.attrs) {
      rule.attrs.forEach(attr => {
        if (attr.name === 'id') {
          return;
        }
        node.push({
          name: attr.name,
          value: attr.value || '',
          operator: attr.operator || ''
        });
      });
    }
    if (rule.pseudos) {
      rule.pseudos.forEach(pseudo => {
        node.push({
          name: ':' + pseudo.name,
          value: pseudo.value,
          operator: pseudo.operator || ''
        });
      });
    }
    nodes.push(node);
    rule = rule.rule;
  }
  return nodes;
}

function generateRuleSetRegEx (rulesetNodes) {
  let regex = '';
  rulesetNodes.forEach((ruleNodes, idx) => {
    regex += generateRegEx(ruleNodes);
    if (idx < (rulesetNodes.length - 1)) {
      // concatenate css selectors seperated by ',', such as '#save1, #save2'
      regex += '|';
    }
  });
  return regex;
}

function generateRegEx (nodes) {
  let regex = '';
  nodes.forEach((node, index) => {
    if (index > 0) {
      if (node.nestingOperator === '>') {
        // handle the match of direct child
        regex += '((\\[[^\\[|^\\]]+\\])*[\\v]){1}';
      } else {
        regex += '((\\[[^\\[|^\\]]+\\])*[\\v])+';
      }
    }
    node.forEach((attr, attrIdx) => {
      // not the first attribute of the first node
      if (!(index === 0 && attrIdx === 0)) {
        // not the absolute first attribute (i.e. tag) of a node
        if (!(attrIdx === 0 && attr.name === 'tag')) {
          regex += '(\\[[^\\[|^\\]]+\\])*';
        }
      }
      let value;
      if (attr.operator === '*=') {
        if (attr.name === 'class') {
          value = '\\.(.*)' + _.escapeRegExp(attr.value) + '(.*)';
        } else {
          value = '(.*)' + _.escapeRegExp(attr.value) + '(.*)';
        }
      } else {
        if (attr.name === 'class') {
          if (attr.value === '.') {
            value = attr.value.replace(/\./g, '(\\.[^\\.\\[\\]\\s]+)*');
          } else {
            value = attr.value.replace(/\./g, '(\\.[^\\.\\[\\]\\s]+)*\\.') + '(\\.[^\\.\\[\\]\\s]+)*';
          }
        } else {
          value = _.escapeRegExp(attr.value);
        }
      }

      let name = attrCode[attr.name] || attr.name;
      if (typeof value === 'undefined' || value === '') {
        value = '.*';
      }
      regex += `\\[${name}=${value}\\]`;
    });
  });
  return regex;
}

function noramlizeRuleset (rulesetNodes) {
  let normalizedNodes = [];
  rulesetNodes.forEach((ruleNodes) => {
    normalizedNodes.push(noramlizeRules(ruleNodes));
  });
  return normalizedNodes;
}

function noramlizeRules (ruleNodes) {
  let normalizedNodes = normalize(ruleNodes);
  ruleNodes.forEach((ruleNode, index) => {
    normalizedNodes[index].nestingOperator = ruleNode.nestingOperator;
  });
  return normalizedNodes;
}



/** WEBPACK FOOTER **
 ** ./src/utils/selectorRegex.js
 **/